import axios from 'axios';

import {
    KYB_API_BASE_URL
} from '../../../../constants/index';

export default class ComplianceScreeningOverviewService {
    static instance;
    resource = `${KYB_API_BASE_URL}/kyb/compliance-screening`;

    static getInstance() {
        if (!ComplianceScreeningOverviewService.instance) {
            ComplianceScreeningOverviewService.instance = new ComplianceScreeningOverviewService();
        }

        return ComplianceScreeningOverviewService.instance;
    }

    async fetchOverviewData(params = {}) {
        const response = await axios.get(
            `${this.resource}/overview`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }
}
